angular.module('LeasePilot').controller('ShowPasswordController', [
  '$scope',
  function($scope) {
    $scope.showPassword = false;
  },
]);
